import React, {useEffect, useState } from 'react';
import {
  Email,
  Facebook,
  GitHub,
  Instagram,
  LinkedIn,
  WhatsApp,
  YouTube,
} from "@material-ui/icons";
import {
  Book,
  ContactPhone,
  Description,
  Home,
  ImportantDevices,
  Info,
} from "@material-ui/icons";
import "./footer.css";
import { Link } from "react-router-dom";
import { HTTP } from "../../api/http-common";


function Footer() {

  const mediaIcons = {
    "Facebook": <Facebook />,
    "Instagram": <Instagram />,
    "LinkedIn": <LinkedIn />,
    "WhatsApp": <WhatsApp />,
    "YouTube": <YouTube />,
    "Email": <Email />,
    "GitHub": <GitHub />
  }

  const socialMediaLinks = [
    {
      media_url: "https://www.linkedin.com/in/mohd-nafees-58172321b/",
      name: "LinkedIn"
    },
    {
      media_url: "https://github.com/uniquedeveloper143",
      name: "GitHub"
    },
    {
      media_url: "mailto:uniquedeveloper143@gmail.com",
      name: "Email"
    },
    {
      media_url: "https://www.facebook.com/mohd.nafees.56027",
      name: "Facebook"
    },
    // {
    //   media_url: "/",
    //   name:"<"YouTube
    // },
    {
      media_url: "https://wa.me/917490078839",
      name: "WhatsApp"
    },
    {
      media_url: "https://www.instagram.com/nafees786_92/",
      name: "Instagram"
    },

  ];
  
  const [mediaURLData, setMediaURLData] = useState(socialMediaLinks);
  
  useEffect(() => {

      // this is call for media_url
      let media_url = '/api/portfolio/media-url/'
      HTTP.get(media_url)
      .then(function (response) {
          console.log(response.status);
          if (response.status === 200 && response.data.results.length > 0) {
            setMediaURLData(response.data.results);
          } else {
            setMediaURLData(socialMediaLinks); // fallback if API returns empty
          }
      })
      .catch(function (err) {
          console.log(err);
      });


    }, []); // 👈 empty array ensures this runs once on component mount

  

  return (
    <footer
      className="text-center text-lg-start text-white mt-5"
      style={{ backgroundColor: "#3e4551", disable: true }}
    >
      <div className="container p-4 pb-0 text-center">
        <section>
          <div className="row">
            <div className="col-lg-12 col-md-6 mb-4 mb-md-0 text-center">
              <h5 className="text-uppercase">Let's Build the Future Together</h5>
              <hr className="mb-4 bg-white" />
              <p className="text">
                Great developers don’t wait to feel ready—they solve problems no one has solved before. 
                I write code, craft systems, and extract insights from data to make a real impact. 
                In a world full of noise, I let data speak. In a world full of problems, 
                I let technology solve.<br/>
                <>Mohd Nafees, Full Stack Software Engineer & Data Scientist</>
              </p>
            </div>
          </div>
          <hr className="mb-4 bg-white" />

          <div className="row">
            <div className="container header ">
              <ul className="me-auto mb-2 mb-lg-0 list-inline">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="/"
                    style={{ color: "white" }}
                  >
                    <Home style={{ marginBottom: "5px" }} /> Home
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/testimonial"
                    style={{ color: "white" }}
                  >
                    <ImportantDevices style={{ marginBottom: "5px" }} />{" "}
                    Testimonial
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/blog"
                    style={{ color: "white" }}
                  >
                    <Book style={{ marginBottom: "5px" }} /> Blog
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/resume"
                    style={{ color: "white" }}
                  >
                    <Description style={{ marginBottom: "5px" }} /> Resume
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/about"
                    style={{ color: "white" }}
                  >
                    <Info style={{ marginBottom: "5px" }} /> About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/contact"
                    style={{ color: "white" }}
                  >
                    <ContactPhone style={{ marginBottom: "5px" }} /> Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <hr className="mb-4 bg-white" />

        <section className="mb-4 text-center">
          <div
            className="link-icons mt-3 text-center"
            style={{ height: "45px" }}
          >

          {
            mediaURLData.map((item, index) => (
              
              <a key={index} href={item.media_url} target="_blank" rel="noreferrer">
                {mediaIcons[item.name]}
              </a>

            ))
          }

          </div>
        </section>
      </div>

      <div
        className="text-center p-3 copy"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
      >
        {/* © 2022 Copyright:  */}
        {/* <a className="text-white" href="https://mdbootstrap.com/">
          Port Folio
        </a> */}
        Copyright &copy;
        <script>document.write(new Date().getFullYear());</script> All rights
        reserved | This template is made by Mohd Nafees.
      </div>
    </footer>
  );
}

export default Footer;
